// extracted by mini-css-extract-plugin
export default {"btnpwd":"_4d9ecea81b"};